(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[42576,65250],{

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TalcumClaimsWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/talcum/logo/index.tsx


function TalcumClaimsLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "313",
        height: "45",
        fill: "none",
        viewBox: "0 0 313 45",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_88)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#62C5BB",
                        d: "M19.399 45a.352.352 0 01-.337-.246.36.36 0 01.227-.448c9.43-3.05 15.983-9.255 17.534-16.596.366-1.727.344-3.41.318-5.195-.007-.434-.01-.871-.01-1.308V8.616a.354.354 0 11.71 0v12.59c-.001.434.006.868.01 1.301.022 1.745.047 3.55-.333 5.353-1.602 7.595-8.334 13.995-18.01 17.125a.382.382 0 01-.11.019V45z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#304598",
                        d: "M54.84 15.68h-7.504v-4.132h19.607v4.133H59.44v21.188h-4.597V15.681h-.003zM70.052 36.09c-1.372-.907-2.447-2.134-3.226-3.685-.779-1.55-1.166-3.251-1.166-5.103 0-1.852.391-3.53 1.177-5.081.786-1.55 1.858-2.785 3.225-3.696a8.017 8.017 0 014.55-1.37c1.557 0 2.936.337 4.142 1.013 1.203.676 2.118 1.61 2.736 2.804v-3.24h4.263v19.141H81.49v-3.222a6.63 6.63 0 01-2.736 2.792c-1.203.669-2.578 1.007-4.124 1.007-1.679 0-3.207-.452-4.578-1.36zm8.48-3.604a5.645 5.645 0 002.029-2.16c.493-.911.742-1.922.742-3.028 0-1.105-.248-2.094-.75-3.005a5.804 5.804 0 00-2.029-2.168 5.211 5.211 0 00-2.816-.8c-1.023 0-1.963.25-2.815.753a5.489 5.489 0 00-2.03 2.112c-.5.908-.75 1.944-.75 3.108 0 1.165.253 2.26.761 3.167.505.908 1.185 1.602 2.037 2.087a5.557 5.557 0 002.797.728 5.348 5.348 0 002.827-.79l-.004-.004zM91.012 10.636h4.483v26.237h-4.483V10.637zM104.198 36.09a9.687 9.687 0 01-3.529-3.685c-.852-1.55-1.28-3.251-1.28-5.103 0-1.852.428-3.53 1.28-5.081a9.743 9.743 0 013.529-3.696c1.499-.911 3.177-1.37 5.031-1.37 1.595 0 3.046.312 4.356.94a9.187 9.187 0 013.28 2.605 10.003 10.003 0 011.854 3.788h-4.579c-.42-1.029-1.06-1.812-1.919-2.348-.86-.533-1.851-.8-2.973-.8-.94 0-1.821.238-2.651.715-.827.478-1.496 1.169-2.001 2.076-.508.908-.76 1.962-.76 3.167 0 1.206.252 2.275.76 3.175.505.9 1.174 1.59 2.001 2.076a5.153 5.153 0 002.651.727c1.137 0 2.135-.283 3.002-.849.863-.565 1.495-1.418 1.89-2.56h4.56a10.123 10.123 0 01-1.806 3.938 8.927 8.927 0 01-3.291 2.682c-1.324.64-2.779.96-4.374.96-1.854 0-3.528-.453-5.031-1.36v.003zM126.233 36.469c-1.342-.65-2.395-1.687-3.159-3.101-.768-1.415-1.148-3.222-1.148-5.42v-10.22h4.446V27.82c0 1.775.38 3.127 1.141 4.049.761.926 1.88 1.389 3.364 1.389 1.485 0 2.6-.467 3.353-1.396.754-.93 1.13-2.278 1.13-4.042V17.727h4.465V27.95c0 2.197-.384 4-1.148 5.408-.768 1.407-1.817 2.443-3.152 3.1-1.335.658-2.878.99-4.633.99s-3.321-.328-4.663-.978h.004zM173.375 19.572c1.203 1.613 1.807 3.942 1.807 6.98V36.87h-4.428V26.648c0-1.826-.352-3.17-1.046-4.041-.699-.868-1.69-1.305-2.973-1.305-.805 0-1.558.246-2.26.735-.706.489-1.269 1.176-1.697 2.058-.428.881-.64 1.88-.64 2.998v9.776h-4.428V26.648c0-1.826-.351-3.17-1.046-4.041-.698-.868-1.682-1.305-2.954-1.305-.805 0-1.558.246-2.26.735-.706.489-1.269 1.176-1.697 2.058-.428.881-.64 1.88-.64 2.998v9.776h-4.428V17.727h4.187l.055 2.98c.504-1.043 1.301-1.896 2.391-2.56 1.086-.666 2.315-.996 3.686-.996 1.58 0 2.904.367 3.968 1.098 1.064.731 1.857 1.808 2.391 3.222.805-1.451 1.77-2.535 2.9-3.248 1.13-.712 2.388-1.069 3.77-1.069 2.358 0 4.143.808 5.346 2.421l-.004-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#62C5BB",
                        d: "M181.299 37.002a2.44 2.44 0 01-1.257-2.142c0-.449.109-.86.325-1.239.216-.378.527-.68.925-.903.402-.225.863-.335 1.382-.335.52 0 .962.11 1.361.335.402.224.713.525.936.903.223.379.333.79.333 1.239 0 .709-.249 1.297-.743 1.767-.493.47-1.13.709-1.909.709-.508 0-.958-.11-1.353-.334z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#304598",
                        d: "M195.513 35.642a13.06 13.06 0 01-4.827-4.806c-1.181-2.024-1.77-4.243-1.77-6.664 0-2.422.589-4.64 1.77-6.658a13.109 13.109 0 014.827-4.794c2.041-1.18 4.275-1.768 6.71-1.768 1.854 0 3.635.368 5.346 1.099 1.712.731 3.182 1.844 4.41 3.332 1.229 1.488 2.03 3.307 2.399 5.456h-4.706c-.483-1.873-1.397-3.284-2.743-4.225-1.345-.944-2.958-1.414-4.838-1.414-1.583 0-3.024.374-4.325 1.128-1.306.75-2.337 1.807-3.094 3.174-.761 1.367-1.141 2.928-1.141 4.692 0 1.763.377 3.358 1.13 4.71.753 1.352 1.781 2.4 3.086 3.137 1.302.739 2.754 1.11 4.344 1.11 1.876 0 3.489-.467 4.838-1.407 1.346-.937 2.257-2.344 2.725-4.218h4.724c-.369 2.16-1.166 3.986-2.391 5.475-1.225 1.488-2.692 2.597-4.403 3.325a13.572 13.572 0 01-5.365 1.087c-2.435 0-4.669-.588-6.71-1.767l.004-.004zM218.25 10.636h4.484v26.237h-4.484V10.637zM231.02 36.09c-1.372-.907-2.447-2.134-3.226-3.685-.778-1.55-1.166-3.251-1.166-5.103 0-1.852.391-3.53 1.177-5.081.787-1.55 1.858-2.785 3.226-3.696a8.017 8.017 0 014.549-1.37c1.557 0 2.936.337 4.143 1.013 1.203.676 2.117 1.61 2.735 2.804v-3.24h4.264v19.141h-4.264v-3.222c-.618 1.19-1.529 2.123-2.735 2.792-1.203.669-2.578 1.007-4.125 1.007-1.682 0-3.207-.452-4.578-1.36zm8.476-3.604a5.64 5.64 0 002.029-2.16c.494-.911.743-1.922.743-3.028 0-1.105-.249-2.094-.75-3.005a5.804 5.804 0 00-2.029-2.168 5.212 5.212 0 00-2.816-.8c-1.024 0-1.964.25-2.816.753-.852.503-1.528 1.208-2.029 2.112-.501.908-.75 1.944-.75 3.108 0 1.165.252 2.26.761 3.167.504.908 1.185 1.602 2.037 2.087a5.555 5.555 0 002.797.728 5.351 5.351 0 002.827-.79l-.004-.004zM252.17 14.017c-.501-.49-.75-1.11-.75-1.852s.249-1.345.75-1.833c.501-.49 1.177-.735 2.029-.735.853 0 1.551.246 2.059.735.505.488.761 1.102.761 1.833 0 .731-.252 1.378-.761 1.863-.508.485-1.199.727-2.077.727-.877 0-1.51-.246-2.011-.735v-.003zm-.194 3.714h4.483v19.142h-4.483V17.731zM290.401 19.572c1.203 1.613 1.806 3.942 1.806 6.98V36.87h-4.428V26.648c0-1.826-.351-3.17-1.046-4.041-.698-.868-1.689-1.305-2.973-1.305-.804 0-1.557.246-2.26.735-.705.489-1.268 1.176-1.696 2.058-.428.881-.64 1.88-.64 2.998v9.776h-4.428V26.648c0-1.826-.351-3.17-1.046-4.041-.699-.868-1.682-1.305-2.955-1.305-.804 0-1.558.246-2.26.735-.705.489-1.269 1.176-1.696 2.058-.428.881-.64 1.88-.64 2.998v9.776h-4.429V17.727h4.187l.055 2.98c.505-1.043 1.302-1.896 2.392-2.56 1.086-.666 2.314-.996 3.686-.996 1.579 0 2.903.367 3.967 1.098 1.064.731 1.858 1.808 2.392 3.222.804-1.451 1.769-2.535 2.899-3.248 1.13-.712 2.388-1.069 3.77-1.069 2.359 0 4.143.808 5.347 2.421l-.004-.003zM299.66 36.517c-1.236-.621-2.158-1.44-2.761-2.458a6.282 6.282 0 01-.907-3.278l4.3.019c.037.918.392 1.66 1.064 2.226.673.566 1.628.849 2.864.849 1.122 0 1.971-.213 2.537-.643.567-.43.852-1.021.852-1.778 0-.522-.15-.94-.446-1.257-.296-.316-.727-.562-1.298-.735-.567-.172-1.327-.334-2.278-.485-2.077-.271-3.73-.867-4.966-1.785-1.236-.919-1.854-2.296-1.854-4.134 0-1.179.278-2.211.834-3.1.556-.89 1.371-1.577 2.446-2.069 1.075-.488 2.373-.735 3.891-.735 1.518 0 2.86.258 4.022.772 1.163.514 2.063 1.238 2.706 2.168.644.93.966 1.998.966 3.203l-4.392-.036c-.051-.732-.355-1.32-.918-1.76-.563-.441-1.349-.662-2.362-.662-.914 0-1.605.199-2.077.596a1.918 1.918 0 00-.706 1.528c0 .496.106.886.315 1.165.208.279.592.514 1.148.709.556.19 1.397.375 2.519.55 1.481.225 2.728.534 3.734.93 1.005.397 1.806.989 2.399 1.768.592.782.888 1.818.888 3.108 0 1.367-.344 2.517-1.027 3.454-.688.936-1.628 1.638-2.827 2.105-1.199.466-2.582.698-4.15.698-1.781 0-3.288-.309-4.524-.93l.008-.003zM27.798 30.745c-2.687 0-4.874-2.198-4.874-4.898v-.022-.03c0-.018.007-.036.01-.055 0-.003 0-.01.005-.014l4.453-11.945c-.6-.367-2.665-1.274-5.627 1.345l-.095.085c-.644.573-1.364 1.216-3.24 1.293v10.908a2.8 2.8 0 002.79 2.803h.245a.34.34 0 01.16.045 2.355 2.355 0 011.906 2.314v1.092a.344.344 0 01-.344.345H12.762a.344.344 0 01-.344-.346v-1.09c0-1.26.988-2.286 2.223-2.352.022-.004.04-.008.063-.008h.245a2.8 2.8 0 002.79-2.803V16.504c-1.927-.066-2.662-.72-3.31-1.297l-.095-.085c-2.962-2.62-5.028-1.715-5.627-1.344l4.454 11.944s0 .011.003.015c.004.018.011.033.011.055V25.843c0 2.7-2.187 4.898-4.874 4.898-2.688 0-4.875-2.197-4.875-4.898v-.022-.029c0-.018.008-.037.011-.055 0-.004 0-.011.004-.015L7.95 13.627c0-.095.044-.19.12-.257.03-.022 2.768-2.249 6.703 1.234l.099.089c.61.547 1.192 1.061 2.852 1.124v-5.603a2.004 2.004 0 01.344-3.979c1.1 0 1.996.9 1.996 2.006 0 .988-.716 1.811-1.652 1.973v5.595c1.605-.073 2.179-.58 2.782-1.12l.099-.085c3.935-3.479 6.677-1.256 6.703-1.234.08.066.12.162.12.257l4.51 12.095s0 .011.003.015c.003.018.01.033.01.055V25.843c0 2.7-2.186 4.898-4.874 4.898l.033.004zm1.748 4.082c-2.325 2.395-5.265 4.405-8.743 5.974a.349.349 0 01-.453-.173.347.347 0 01.171-.456c3.398-1.532 6.268-3.494 8.531-5.827a.341.341 0 01.487-.003.348.348 0 01.007.488v-.003zM2.015 9.5v6.415a.344.344 0 11-.688 0v-6.75c0-.19.15-.34.337-.345 1.89-.036 4.11-.514 6.597-1.41a.344.344 0 01.234.647c-2.41.87-4.59 1.355-6.48 1.44V9.5zM18.086 0C16.58 1.043 7.357 7.212 0 7.54v17.403c0 .019.146 3.281 2.45 7.194 2.117 3.597 6.55 8.49 15.636 11.43 9.087-2.94 13.519-7.833 15.636-11.43 1.002-1.701 1.763-3.556 2.165-5.496.366-1.767.285-3.513.285-5.302V7.536C28.815 7.212 19.592 1.043 18.086 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#304598",
                        d: "M19.399 8.245c0-.724-.589-1.316-1.31-1.316a1.316 1.316 0 000 2.631c.721 0 1.31-.592 1.31-1.315zM4.278 25.502h8.067l-4.033-10.82-4.034 10.82zM23.765 25.502h8.067l-4.034-10.82-4.033 10.82z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_88",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H312.188V45H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (TalcumClaimsLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/talcumclaimsWrapper.tsx









const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
function TalcumClaimsWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails: { region  } ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Talcum",
                    domain: "TalcumClaims.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Talcum",
                    domain: "TalcumClaims.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        textColor: "#444B53",
                        slogan: `Find the Best Lawyers for Your Talcum Injuries ${region ? `in ${region}` : ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ })

}]);